import { PrimaryButton, SecondaryButton } from '@procurify/ui'

import { type FeatureExpansionRequestType } from '@webapp/core/services/Marketo'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useTakeProductTourButtonPresenter } from './useTakeProductTourButtonPresenter'

const toKebabCase = (str: string) => {
  return str.toLocaleLowerCase().split(' ').join('-')
}

interface ITakeProductTourButtonPresenterProps {
  context: FeatureExpansionRequestType
  buttonText?: string
  title?: string
  variant?: 'primary' | 'secondary'
  onTourOpened?: () => void
}

export const TakeProductTourButtonPresenter = ({
  context,
  buttonText,
  title,
  variant = 'secondary',
  onTourOpened,
}: ITakeProductTourButtonPresenterProps) => {
  const intl = useProcurifyIntl()
  const {
    data: { tourUrl },
    states: { isOpening },
    commands: { openTour },
  } = useTakeProductTourButtonPresenter({ context, title, onTourOpened })

  if (!tourUrl) {
    return null
  }

  const Button = variant === 'primary' ? PrimaryButton : SecondaryButton

  return (
    <Button
      type='button'
      onClick={openTour}
      isLoading={isOpening}
      data-analytics-id={`take-${toKebabCase(context)}-tour-button`}
    >
      {buttonText ?? intl.formatMessage(messages.takeTour)}
    </Button>
  )
}

TakeProductTourButtonPresenter.displayName = 'TakeProductTourButtonPresenter'
